import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function EmailVerificationPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <Card className="mx-auto max-w-sm">
        <CardHeader>
          <CardTitle className="text-2xl">{t('emailVerification.title')}</CardTitle>
          <CardDescription>{t('emailVerification.description')}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">{t('emailVerification.emailLabel')}</Label>
              <Input id="email" type="email" placeholder="m@example.com" required />
            </div>
            <Button type="submit" className="w-full">
              {t('emailVerification.submitButton')}
            </Button>
          </div>
          <div className="mt-4 text-center text-sm">
            {t('emailVerification.backToLogin')}{' '}
            <Link to="/login" className="underline">
              {t('emailVerification.loginLink')}
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
